<template>
  <div class="feeds">
    <!-- Filter tabs -->
    <ul class="nav nav-tabs">
      <li class="nav-item" @click="changeFilter('forwardFitness')">
        <div
          class="nav-link"
          :class="{ active: activeFilter === 'forwardFitness' }"
        >
          Forward Fitness
        </div>
      </li>

      <li class="nav-item" @click="changeFilter('filter2')">
        <div class="nav-link" :class="{ active: activeFilter === 'filter2' }">
          Filter 2
        </div>
      </li>

      <li class="nav-item" @click="changeFilter('filter3')">
        <div class="nav-link" :class="{ active: activeFilter === 'filter3' }">
          Filter 3
        </div>
      </li>
    </ul>

    <!-- Loading -->
    <VaProgressCircle v-if="!feeds[activeFilter]" v-show="true" indeterminate />

    <!-- Table -->
    <div v-if="feeds[activeFilter]">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Název</th>
            <th scope="col">Skladovost</th>
            <th scope="col">Poslední úprava</th>
            <th scope="col">Náš produkt</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in feeds[activeFilter]" :key="item.id">
            <td>{{ item.product }}</td>
            <td>{{ item.stock }}</td>
            <td>{{ dayjs(item.updated_at).format("DD.MM.YYYY HH:mm:ss") }}</td>

            <td>
              <!-- BUTTON IF NOTHING IS SELECTED -->
              <input
                type="submit"
                v-if="!item.linked_product"
                class="btn btn-yellow"
                @click="openModal(item)"
                value="Napojit produkt"
              />

              <!-- DISPLAY PICKED PRODUCT -->
              <p v-else class="linked-product-display" @click="openModal(item)">
                {{
                  [
                    item.linked_product.name,
                    item.linked_product?.variant ?? item.linked_product?.color
                      ? item.linked_product?.color?.color_name
                      : "",
                  ]
                    .filter(Boolean)
                    .join(", ")
                }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ------------------------------ -->
    <!--            MODAL              -->
    <!-- ------------------------------ -->

    <div
      class="modal fade"
      id="productModal"
      tabindex="-1"
      aria-hidden="true"
      ref="productModal"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Vybrat produkt</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <div class="modal-body">
            <!-- SEARCH INPUT -->
            <input
              type="text"
              class="form-control mb-3 list-group-item"
              v-model="modalInput"
              @input="fetchSuggestionsDebounced(modalInput)"
              placeholder="Hledat produkt..."
            />

            <ul class="list-group">
              <li v-if="loadingSuggestions" class="list-group-item">
                Hledám produkty...
              </li>

              <li
                v-else-if="!suggestions.length"
                class="list-group-item text-muted"
              >
                Žádný produkt nebyl nalezen
              </li>

              <li
                v-else
                v-for="(s, i) in suggestions"
                :key="i"
                class="list-group-item list-group-item-action"
                @click="modalSelected = s"
                :class="{ active: modalSelected?.id === s.id }"
              >
                {{
                  [s.name, s?.variant ?? s?.color?.color_name]
                    .filter(Boolean)
                    .join(", ")
                }}
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <input
              type="submit"
              class="btn btn-red"
              @click="clearSelected"
              :disabled="!modalRow || !modalRow.linked_product"
              value="Vymazat"
            />

            <input
              type="submit"
              class="btn btn-yellow"
              @click="confirmModalSelection"
              data-bs-dismiss="modal"
              value="Potvrdit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../api";
import { VaProgressCircle } from "vuestic-ui";
import dayjs from "dayjs";
import * as bootstrap from "bootstrap";

export default {
  components: { VaProgressCircle },

  data() {
    return {
      activeFilter: "forwardFitness",
      feeds: {
        forwardFitness: null,
        filter2: null,
        filter3: null,
      },

      suggestions: [],
      abortController: null,
      loadingSuggestions: false,
      debounceTimeout: null,

      modalRow: null,
      modalInput: "",
      modalSelected: null,
      modalOriginal: null,
      modalWasCleared: false,
      modalInstance: null,
    };
  },

  computed: {
    dayjs() {
      return dayjs;
    },
  },

  methods: {
    async fetchFeed(filter) {
      if (this.feeds[filter] !== null) return;

      try {
        const response = await axios.post("/api/feeds", { filter });
        this.feeds[filter] = response.data;
      } catch (err) {
        console.error(err);
      }
    },

    async changeFilter(filter) {
      this.activeFilter = filter;
      await this.fetchFeed(filter);
    },

    fetchSuggestionsDebounced(value) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.fetchSuggestions(value);
      }, 200);
    },

    async fetchSuggestions(value) {
      if (this.abortController) this.abortController.abort();

      if (!value) {
        this.suggestions = [];
        return;
      }

      this.abortController = new AbortController();
      this.loadingSuggestions = true;

      try {
        const response = await axios.get("/api/products/" + value, {
          signal: this.abortController.signal,
        });
        this.suggestions = response.data;
      } catch (error) {
        this.suggestions = [];
      } finally {
        this.loadingSuggestions = false;
      }
    },

    openModal(row) {
      this.modalRow = row;
      this.modalOriginal = row.linked_product;
      this.modalWasCleared = false;

      this.modalSelected = row.linked_product || null;
      this.modalInput = row.linked_product
        ? [
            row.linked_product.name,
            row.linked_product?.variant ?? row.linked_product?.color
              ? row.linked_product?.color?.color_name
              : "",
          ]
            .filter(Boolean)
            .join(", ")
        : "";

      this.fetchSuggestionsDebounced(this.modalInput);

      if (!this.modalInstance) {
        this.modalInstance = new bootstrap.Modal(this.$refs.productModal);
      }

      this.modalInstance.show();
    },

    clearSelected() {
      if (!this.modalRow) return;
      this.modalWasCleared = true;
      this.modalSelected = null;
      this.modalInput = "";
    },

    async confirmModalSelection() {
      const item = this.modalRow;
      const originalId = this.modalOriginal?.id || null;
      const selectedId = this.modalSelected?.id || null;

      // only call BE if changed
      if (originalId === selectedId) return;

      try {
        await axios.post(`/api/feedItem/${item.id}/save`, {
          linkedProduct: this.modalSelected || null,
        });
        this.$snackbar.add({
          type: "success",
          text: "Stav byl uložen",
        });
        item.linked_product = this.modalSelected;
      } catch (error) {
        console.error(error);
        this.$snackbar.add({
          type: "error",
          text: "Nepodařilo se stav uložit",
        });
      }
    },
  },

  mounted() {
    this.fetchFeed(this.activeFilter);
  },
};
</script>

<style lang="scss" scoped>
.feeds {
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

.list-group-item.active {
  background-color: $yellow !important;
  border-color: $yellow !important;
}

/* Makes modal buttons equal width */
.modal-footer {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

#productModal .modal-footer > .btn {
  flex: 1;
}

/* Linked product styling */
.linked-product-display {
  padding: 0.4rem 0.8rem;
  background: $white;
  border: 1px solid $yellow;
  border-radius: 0.8rem;
  cursor: pointer;
  display: inline-block;
  transition: 0.2s ease;
  width: 210px;
}

.linked-product-display:hover {
  background: $yellow;
  color: $white;
}

td .btn {
  width: 210px;
}
</style>
